import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";

import { MenuController } from "@ionic/angular/standalone";

import { QuangAuthService } from "quang/auth";
import { OAuthService } from "angular-oauth2-oidc";

import packageInfo from "../../../../package.json";
import * as ROLE from "../constants/roles.contants";
import { environment } from "../../../environments/environment";
import { AuthControllerService } from "../../store/auth-controller.service";
import { TranslocoPipe } from "@jsverse/transloco";
import {
  IonAvatar,
  IonContent,
  IonItem,
  IonMenu,
} from "@ionic/angular/standalone";

@Component({
  selector: "bm-aside",
  templateUrl: "./aside.component.html",
  styleUrls: ["./aside.component.scss"],
  imports: [TranslocoPipe, IonAvatar, IonContent, IonItem, IonMenu],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AsideComponent {
  readonly ROLE = ROLE;

  readonly authController = inject(AuthControllerService);
  private readonly authService = inject(QuangAuthService);
  private readonly oauthService = inject(OAuthService);
  private readonly menuController = inject(MenuController);
  private readonly router = inject(Router);

  appVersion: string = packageInfo.version;

  readonly isAdministrator = computed(() =>
    this.authController.hasRole(ROLE.ROLE_ADMINISTRATOR),
  );

  readonly isRoleManager = computed(() =>
    this.authController.hasRole(ROLE.ROLE_MANAGER),
  );

  readonly isCompiler = this.authController.isCompiler;

  goToHome(): void {
    this.navigate("/home");
  }

  navigate(page: string): void {
    this.router.navigate([page]);
    this.menuController.close();
  }

  logout(): void {
    this.manageLogout();
  }

  manageLogout(): void {
    this.authController.clearAuth();
    if (environment.isApp) {
      // On iOS: revoke token first, then trigger reload for re-login
      try {
        this.oauthService
          .revokeTokenAndLogout(false, true)
          .then(() => this.triggerLogin())
          .catch(() => this.triggerLogin());
      } catch {
        this.triggerLogin();
      }
    } else {
      this.authService.logout().then(() => this.triggerLogin());
    }
  }

  triggerLogin(): void {
    this.oauthService.logOut(true);
    this.oauthService.stopAutomaticRefresh();
    window.location.reload();
  }
}
